import ConditionScore from './ConditionScore.jsx';

const TYPE_LABEL = {
  trail: 'trail',
  tour: 'tour',
  ride: 'ride',
  wildlife_viewing: 'wildlife',
  urban: 'in town',
};

export default function ActivityCard({ activity, trail, score, onOpen }) {
  const name = activity.name || trail?.name || activity.id;
  const subtitle = activity.subtitle;
  const type = TYPE_LABEL[activity.type] || activity.type;
  const lengthMi = trail?.length_miles;
  const elevFt = trail?.elevation_gain_feet;
  const difficulty = trail?.difficulty;
  const rating = trail?.avg_rating;
  const driveTime = activity.drive_time_from_lodging_minutes;

  return (
    <button
      type="button"
      onClick={onOpen}
      className="card flex w-full flex-col gap-2 px-4 py-3 text-left transition hover:bg-bg-tertiary"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="font-mono text-[10px] uppercase tracking-wider text-fg-tertiary">{type}</p>
          <h3 className="truncate font-medium">{name}</h3>
          {subtitle && (
            <p className="truncate text-xs text-fg-secondary">{subtitle}</p>
          )}
        </div>
        {Number.isFinite(score?.score) && <ConditionScore score={score.score} />}
      </div>

      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 font-mono text-[11px] text-fg-secondary">
        {Number.isFinite(lengthMi) && <span>{lengthMi.toFixed(1)} mi</span>}
        {Number.isFinite(elevFt) && <span>↑ {elevFt} ft</span>}
        {difficulty && <span>{difficulty}</span>}
        {Number.isFinite(rating) && <span>★ {rating.toFixed(1)}</span>}
        {Number.isFinite(driveTime) && <span>{driveTime} min drive</span>}
      </div>

      {score?.reasons?.length > 0 && (
        <p className="line-clamp-2 text-xs text-fg-secondary">
          {score.reasons[0]}
          {score.reasons[1] ? ` · ${score.reasons[1]}` : ''}
        </p>
      )}
    </button>
  );
}
